export enum GroupByPeriod {
    Days = "days",
    Weeks = "weeks",
    Months = "months",
    Years = "years",
}
